import AbstractSlopedRightRectangle from "./AbstractSlopedRightRectangle";

export default class SlopedRightRectangle extends AbstractSlopedRightRectangle {
	static NAME = "sloped-right-rectangle";

	get_name() {
		return SlopedRightRectangle.NAME;
	}
}
